import { createI18n } from 'vue-i18n';

import login from './en/login-translation.json';
import logout from './en/logout-translation.json';
import home from './en/home-translation.json';
import notFound from './en/pageNotFound-translation.json';
import client from './en/client-translation.json';
import attributes from './en/attributes-translation.json';
import filters from './en/filters-translation.json';
import systems from './en/systems-translation.json';
import tools from './en/tools-translation.json';
import codeEditor from './en/codeEditor-translation.json';
import about from './en/about-translation.json';
import header from './en/appPrimaryHeader-translation.json';
import sideBar from './en/appSideBar-translation.json';
import confirmationPopup from './en/confirmationPopup-translation.json';
import errorMessages from '@/app/locales/en/errorMessages-translation.json';
import passwordChange from './en/passwordChange-translation.json';
import searchPanel from './en/searchPanel-translation.json';
import codeTab from '@/app/locales/en/codeTab-translations.json';
import sessionExpiry from '@/app/locales/en/session-expiry-translation.json';
import massDelete from '@/app/locales/en/massDelete-translation.json';
import importFile from '@/app/locales/en/import-translation.json';
import ExportFile from '@/app/locales/en/export-translation.json';
import batch from '@/app/locales/en/batch-translation.json';
import user from './en/user-translation.json';
import role from './en/role-translation.json';
import deploy from './en/deploy-translation.json';

export const defaultLocale = 'en';
const en = Object.assign(
  {},

  login,
  logout,
  home,
  notFound,
  client,
  attributes,
  filters,
  systems,
  tools,
  codeEditor,
  about,
  header,
  sideBar,
  confirmationPopup,
  passwordChange,
  searchPanel,
  codeTab,
  sessionExpiry,
  massDelete,
  errorMessages,
  importFile,
  ExportFile,
  batch,
  user,
  role,
  deploy
);

export const languages = { en };
const messages = Object.assign(languages);

const i18n = createI18n({
  legacy: false,
  runtimeOnly: true,
  compositionOnly: true,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages,
});

export default i18n;
